import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardTitle } from "components/ui/Card";
import { Spinner } from "components/ui/Spinner";
import { LargeSpacer } from "components/ui/VerticalSpacers";

import FinancialAidYearContext from "components/contexts/FinancialAidYearContext";
import { useFinaidYear } from "components/hooks/useFinaidYear";
import { dispatchUserFinaidSlice } from "components/hooks/dispatchUserFinaidSlice";
import { fetchFinaidAwardsByTerm } from "data/slices/users/finaid/finaidAwardsByTerm";

import { AwardsByTermCategory } from "./AwardsByTermCategory";
import { AwardsByTermContext } from "./AwardsByTermContext";

export function AwardsByTermCardUI() {
  dispatchUserFinaidSlice(fetchFinaidAwardsByTerm);

  const finaidAwardsByTerm =
    useFinaidYear(({ finaidAwardsByTerm }) => finaidAwardsByTerm) || {};

  const { aidYear, loadState: contextLoadState } = useContext(
    FinancialAidYearContext
  );

  const {
    loadState,
    feed: {
      awards: { semester: { data: categories = [] } = {} } = {},
      message,
    } = {},
  } = finaidAwardsByTerm;

  const amounts = categories
    .flatMap((category) => category.items)
    .flatMap((item) => {
      if (item.amounts) {
        return item.amounts;
      } else if (item.totals) {
        return item.totals;
      }
    })
    .filter(Boolean);

  const useDecimals = !amounts.every(Number.isInteger);

  return (
    <AwardsByTermContext.Provider value={{ useDecimals }}>
      <Card>
        <CardTitle>
          <h2>Awards By Term</h2>

          {contextLoadState === "success" && (
            <Link to={`/finances/finaid/${aidYear.id}`}>
              <strong>
                View By Year <i className="fa fa-arrow-right" />
              </strong>
            </Link>
          )}
        </CardTitle>
        <CardBody>
          {loadState === "pending" && <Spinner />}
          {loadState === "success" && (
            <>
              <div dangerouslySetInnerHTML={{ __html: message }} />
              <LargeSpacer />
              <div
                style={{
                  display: `flex`,
                  flexDirection: `column`,
                  gap: `var(--lg)`,
                }}
              >
                {categories.map((category, index) => (
                  <AwardsByTermCategory key={index} category={category} />
                ))}
              </div>
            </>
          )}
        </CardBody>
      </Card>
    </AwardsByTermContext.Provider>
  );
}
